export default __webpack_public_path__ + "static/media/14.5f8cc699.png";